module.exports = require("axios");


/*****************
 ** WEBPACK FOOTER
 ** external "axios"
 ** module id = 7
 ** module chunks = 0
 **/